import styled from "@emotion/styled";
import { ModalActions, Typography } from "@kaltura/ds-react-components";

export const StyledTypography = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(4),
}));

export const StyledModalActions = styled(ModalActions)(({ theme }) => ({
    borderTop: `1px solid ${theme.kaltura.palette.tone4}`,
    padding: theme.spacing(2),
}));
